"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberUtilities = void 0;
var sha1_1 = __importDefault(require("crypto-js/sha1"));
var crypto_1 = __importDefault(require("crypto"));
exports.numberUtilities = {
    /**
     * Formats a number so that there is a thousands separator in all the relevant places.
     * @param numberToSeparate number. The number to apply the formatting on.
     * @returns string. A string with the number separated by commas, e.g. 1,000,000
     */
    separateNumberByThousands: function (numberToSeparate) {
        return numberToSeparate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    /**
     * Generates a random number between two values.
     * @param min number. The starting range.
     * @param max number. The range end.
     * @returns number. A random number between the min and max values provided.
     */
    getRandomNumber: function (min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    },
    /**
     * Formats a number to the locale string with 2 decimals if there is at least one decimal in the number
     * @param number number. The number to format.
     * @param defaultLocale string. The default locale to use.
     * @param alwaysShowZeros boolean (optional). Used for the odds, where we want to always show 2 decimals, even if the ood has no decimals. (4 => 4.00)
     * @param useEng boolean (optional). A flag to indicate whether or not to use the English locale.
     * @returns string. A string with the number formatted to the relevant locale.
     */
    formatNumberToLocale: function (number, defaultLocale, alwaysShowZeros, useEng) {
        if (alwaysShowZeros === void 0) { alwaysShowZeros = false; }
        if (useEng === void 0) { useEng = false; }
        var locale = 'en';
        if (!useEng) {
            locale = defaultLocale !== '' ? defaultLocale : window.navigator.language;
        }
        if (number % 1 === 0 && !alwaysShowZeros) {
            return number.toLocaleString(locale);
        }
        else {
            return number.toLocaleString(locale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
    },
    getUniqueId: function () {
        var uniqueId = (crypto_1.default.randomBytes(25).toString('hex') + Date.now()).toString();
        return sha1_1.default(uniqueId).toString();
    }
};
